module.exports = __webpack_public_path__ + "static/d09ff1340748982062b98b821f140c1aee4585c72371d4ad088db883860a16b5-f1c3c4ee370b380e9147eecb03a976db.jpeg";